/* istanbul ignore file */
import {
    UPDATE_DRIVER,
} from './types'

export function updateDriver (driver) {
    return {
        type: UPDATE_DRIVER,
        driver,
    }
}
